import classnames from "classnames";
import React from "react";
import { useFormContext } from "react-hook-form";
import "../styles.scss";

export const SimpleWrapper = ({
  children,
  label,
  subLabel = null,
  name,
  extrasClasses='',
}) => {
  const { formState, errors } = useFormContext();
  let hasError = !!Object.byString(errors, name);
  let showCheck = false;
  if (formState.dirtyFields[name]) {
    showCheck = !hasError;
  }
  return (
    <React.Fragment>
      <div className={"container-accidentes w-100" + extrasClasses}>
        <label
          className="accidentes text-left"
          htmlFor={name}
          style={{ fontSize: "20px" }}
        >
          {label}
          {showCheck && <div className="img-input-active ">&nbsp;</div>}
        </label>
        <div className="container-input-accidentes">
          <div className="row">
            <div
              className={classnames({
                "my-2": true,
                "col-10": subLabel !== null,
                "col-12": !subLabel,
              })}
            >
              {children}
            </div>
            {subLabel && (
              <div className="col-2 mt-2">
                <div className="placeholder-full-input-type1 mt-2 mb-2">
                  {subLabel}
                </div>
              </div>
            )}
          </div>
          {Object.byString(errors, name) && (
            <strong className="error-msg-input">
              {Object.byString(errors, name).message}
            </strong>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

//Contenedor para que la etiqueta se muestre a lado izquierdo y no arriba
export const SimpleWrapperB = ({
  children,
  label,
  subLabel,
  fontTam,
  name,
  colLeft,
  colRight,
  containerActive = true,
  extrasClasses = "mb-2",
  normal = false,
  textAlign = "text-left",
}) => {
  const { formState, errors } = useFormContext();
  let hasError = Object.byString(errors, name) !== undefined;
  let showCheck = false;
  if (formState.dirtyFields[name]) {
    showCheck = !hasError;
  }
  return (
    <React.Fragment>
      {!normal && (
        <React.Fragment>
          <div
            className={`${
              containerActive ? "container-accidentes w-100" : ""
            } ${extrasClasses}`}
          >
            <div className="row">
              <div
                className={`${colLeft ? colLeft : "col"} ${
                  colRight === "col-12" ? "d-none" : ""
                } my-auto`}
              >
                <label
                  className={`w-100 ${textAlign} my-auto mx-1`}
                  htmlFor={name}
                  style={{ fontSize: fontTam ? fontTam : "1rem" }}
                >
                  {label}
                  {showCheck && <div className="img-input-active ">&nbsp;</div>}
                </label>
              </div>
              <div
                className={`${colRight ? colRight : "col"} ${
                  colLeft === "col-12" ? "d-none" : ""
                } my-auto`}
              >
                <div className="container-input-accidentes py-1">
                  <div className="d-flex">
                    {subLabel && <div className="my-auto ml-2">{subLabel}</div>}
                    {children}
                  </div>

                  {Object.byString(errors, name) && (
                    <div className="ml-2">
                      <strong style={{ color: "#cf0e18" }}>
                        {Object.byString(errors, name).message}
                      </strong>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
      {normal && (
        <React.Fragment>
          <div className={"container-accidentes w-100" + extrasClasses}>
            <label
              className="accidentes text-left"
              htmlFor={name}
              style={{ fontSize: "20px" }}
            >
              {label}
              {showCheck && <div className="img-input-active ">&nbsp;</div>}
            </label>
            <div className="container-input-accidentes">
              <div className="d-flex">
                {subLabel && (
                  <div className="placeholder-full-input-type1 my-auto ml-3 mr-2">
                    {subLabel}
                  </div>
                )}
                <div className="my-2 w-100">{children}</div>
              </div>
              {Object.byString(errors, name) && (
                <strong className="error-msg-input">
                  {Object.byString(errors, name).message}
                </strong>
              )}
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};


